module.exports = __webpack_public_path__ + "static/img/page65.f1223e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page65.jpg
// module id = b2CC
// module chunks = 0